define('plugin/news/collection/NewsCollection',['require','lib/collection/BaseCollection','plugin/news/model/NewsModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var NewsModel = require('plugin/news/model/NewsModel');

    /**
     * News collection
     *
     * @class NewsCollection
     */
    return BaseCollection.extend({

        url: '/ext/news/',
        model: NewsModel

    });

});
